<template>
  <div class="exam-share-page">
    <exam-share-detail />
  </div>
</template>

<script>
import ExamShareDetail from "./examShareDetail.vue";

export default {
  name: "ExamShare",
  components: {
    ExamShareDetail,
  },
};
</script>

<style scoped>
.exam-share-page {
  width: 100%;
  min-height: 100vh;
  background: #f5f7f9;
}
</style>
